module.exports = __webpack_public_path__ + "img/prev-quiz-title.3aec8432.svg";